(function processDefinition() {
    'use strict';
    angular.module('Entities')
        .service('processService', [
            'restUrlBuilder', '$injector', 'config', 'authExtend', function processService(restUrlBuilder, $injector, config, authExtend) {

                var wfBuilder = restUrlBuilder('wf');
                var signprocesses = undefined;

                this.get = function get(find) {
                    var params = {
                        OrganizationalUnitId: find.ouId,
                        Name: find.name,
                        orderBy: find.orderBy
                    };

                    return wfBuilder.all('processes').get({ params: params });
                };

                this.getById = function getById(id) {

                    return wfBuilder.one('processes', id).get();
                };

                this.getHistory = function getHistory(id, currentPage, itemsPerPage) {
                    var params = {
                        page: currentPage,
                        itemPerPage: itemsPerPage,
                        processId: id
                    }

                    return wfBuilder.all('processes/logs').get({ params: params });
                };

                this.checkout = function checkout(id) {

                    return wfBuilder.one('processes/checkout', id).put();
                };

                this.checkin = function checkin(id) {

                    return wfBuilder.one('processes/checkin', id).put();
                };

                this.execute = function execute(id) {

                    return wfBuilder.one('processes/execute', id).put();
                };

                this.delete = function deleteProcess(id) {

                    return wfBuilder.one('processes', id).delete();
                };

                this.deleteBatch = function deleteBatch(process) {
                    var params = {
                        ids: process
                    };
                    return wfBuilder.all('processes/DeleteBatch').put(params);
                };

                this.modify = function modify(process) {
                    return wfBuilder.all('processes').put(process);
                };

                this.modifyAndSend = function modifyAndSend(process) {
                    return wfBuilder.all('processes/ModifyAndSend').put(process);
                };

                this.manualActionBatch = function modifyAndSend(processes) {
                    return wfBuilder.all('processes/ManualActionBatch').put(processes);
                };

                this.advancedGet = function advancedGet(params) {

                    return wfBuilder.all('processes/find').put(params);
                };

                this.exportToXLS = function (filters, headers, sheetName) {
                    var params = {
                        filters: filters,
                        headers: headers,
                        sheetName: sheetName
                    };

                    return wfBuilder.all('exportProcess/exportxls').put(params);
                };

                this.createBatch = function (processes, files, multipleFilesByProcess) {
                    var url = 'Processes/Batch';

                    if (processes == null) {
                        throw "el proceso no puede ser null";
                    }

                    if (files == null || files.size <= 0) {
                        throw "file no puede ser null";
                    }

                    if (multipleFilesByProcess) {
                        url = 'Processes/BatchMultipleFiles';
                    }

                    var $upload = $injector.get('Upload');
                    if ($upload == null)
                        throw "No se pudo instanciar $upload. Verifique que se cargó el script ng-file-upload";

                    return $upload.upload({
                        url: wfBuilder.all(url).url,
                        method: 'POST',
                        fields: { processes: JSON.stringify(processes) },
                        file: files,
                        fileFormDataName: 'imageFile'
                    });
                };


                this.createMultiplePaychecks = function (processes, files) {
                    var cppBuilder = restUrlBuilder('cpp');

                    if (files == null || files.size <= 0) {
                        throw "file no puede ser null";
                    }

                    if (processes == null) {
                        throw "el proceso no puede ser null";
                    }

                    var $upload = $injector.get('Upload');
                    if ($upload == null) {
                        throw "No se pudo instanciar $upload. Verifique que se cargó el script ng-file-upload";
                    }

                    return $upload.upload({
                        url: cppBuilder.all('Processes').url,
                        method: 'POST',
                        fields: { processes: JSON.stringify(processes) },
                        file: files,
                        fileFormDataName: 'imageFile'
                    });
                };

                this.createCertificate = function (params) {

                    if (params == null) {
                        throw "el proceso no puede ser null";
                    }

                    var mvs = [{ "SystemName": "_idLegajo", "Value": params.legajoId }];
                    var process = {
                        MetadataValues: mvs,
                        ProcessTypeId: params.processTypeId,
                        Name: params.processTypeName,
                        OrganizationalUnitId: params.organizationalUnitId,
                        WorkFlowId: 3
                    };

                    return wfBuilder.all('processes').post(process);
                };

                this.setSignProcesses = function (processes) {
                    signprocesses = processes;
                }

                this.getSignProcesses = function () {
                    if (signprocesses) {
                        return signprocesses;
                    } else {
                        return [];
                    }
                }

                this.testPaycheck = function (process, file) {
                    var url = 'Processes/TestAction';

                    if (process == null) {
                        throw "el proceso no puede ser null";
                    }

                    if (file == null) {
                        throw "file no puede ser null";
                    }

                    var $upload = $injector.get('Upload');
                    if ($upload == null)
                        throw "No se pudo instanciar $upload. Verifique que se cargó el script ng-file-upload";

                    return $upload.upload({
                        url: wfBuilder.all(url).url,
                        method: 'POST',
                        fields: { process: JSON.stringify(process) },
                        file: file,
                        fileFormDataName: 'imageFile'
                    });
                };
            }
        ]);
})();